module.exports = __webpack_public_path__ + "mobile/img/img_page_bg1.7d90ac82.png";